import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

type OrderFormLayoutProps = {
  leftColumn: ReactNode;
  rightColumn: ReactNode;
  isMobile: boolean;
  className?: string;
};

export function OrderFormLayout({
  leftColumn,
  rightColumn,
  isMobile,
  className,
}: OrderFormLayoutProps) {
  return (
    <div
      className={cn('tw:flex tw:gap-4', isMobile && 'tw:flex-col', className)}
    >
      {/* Left Column - Order Items */}
      <div className="tw:flex tw:flex-2">
        <div className="tw:flex tw:flex-1 tw:flex-col tw:gap-4">
          {leftColumn}
        </div>
      </div>

      {/* Right Column - Order Info & Cost Summary */}
      <div
        className={cn(
          'tw:flex tw:flex-1 tw:flex-col tw:gap-4',
          !isMobile && 'tw:min-w-[408px]',
        )}
      >
        {rightColumn}
      </div>
    </div>
  );
}
